<template>
    <v-container fluid>
        <v-slide-y-transition mode="out-in">
          <v-tabs
            centered
            slot="extension"
            slider-color="blue"
            v-model="model"
            show-arrows
            >
              <v-tab
                  v-for="(tab, i) in tabs"
                  :key="i"
                  :href="`#tab-${i}`"
              >
                  {{ tab.title }}
              </v-tab>
            <v-tabs-items v-model="model">
                <v-tab-item
                    v-for="(tab, i) in tabs"
                    :key="i"
                    :id="`tab-${i}`"
                >
                    <v-card text>
                        <v-card-text>
                            <component :is="tabComponent"></component>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-slide-y-transition>
    </v-container>
</template>

<script>
  import NonProfitCampaignType from './campaigns/campaign-type/Nonprofit.vue'
  import Audiences from './campaigns/audiences/Index.vue'
  import Issues from './campaigns/issues/Index'
  import Messages from './campaigns/messages/Index'
  import SuccessMetrics from './campaigns/success-metrics/Index'
  import FlightDetails from './campaigns/flight-details/Index'

  export default {
    components: {
      NonProfitCampaignType,
      Audiences,
      Issues,
      Messages,
      SuccessMetrics,
      FlightDetails
    },
    data () {
      return {
        model: 'tab-0',
        tabs: [
          {
            title: 'Campaign Type'
          },
          {
            title: 'Schedule & Budget'
          },
          {
            title: 'Target list'
          },
          {
            title: 'Topics'
          },
          {
            title: 'Messages'
          },
          {
            title: 'Success Metrics'
          }
        ]
      }
    },
    computed: {
      tabComponent () {
        switch (this.model) {
          case 'tab-0':
            return 'non-profit-campaign-type'
          case 'tab-1':
              return 'flight-details'
          case 'tab-2':
            return 'audiences'
          case 'tab-3':
            return 'issues'
          case 'tab-4':
            return 'messages'
          case 'tab-5':
            return 'success-metrics'
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>
